import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { hasPermissionToPostListings } from '../../util/userHelpers';
import classNames from 'classnames';
import { ACCOUNT_SETTINGS_PAGES } from '../../routing/routeConfiguration';
import { LinkTabNavHorizontal } from '../../components';

import css from './UserNav.module.css';

/**
 * A component that renders a navigation bar for a user-specific pages.
 *
 * @component
 * @param {Object} props
 * @param {string} [props.className] - Custom class that extends the default class for the root element
 * @param {string} [props.rootClassName] - Custom class that overrides the default class for the root element
 * @param {string} props.currentPage - The current page (e.g. 'ManageListingsPage')
 * @returns {JSX.Element} User navigation component
 */
const UserNav = props => {
  const { className, rootClassName, currentUser, currentPage } = props;
  const classes = classNames(rootClassName || css.root, className);

  const currentAdminToken = currentUser?.attributes?.profile?.metadata?.adminToken || 'none';
  const showSponsorListingsLink = currentAdminToken === process.env.REACT_APP_ADMIN_USER_TOKEN;

  let tabs = [
    {
      text: <FormattedMessage id="ManageFavoriteListingsPage.yourFavorites" />,
      selected: currentPage === 'ManageFavoriteListingsPage',
      linkProps: {
        name: 'ManageFavoriteListingsPage',
      },
    },
    {
      text: <FormattedMessage id="UserNav.profileSettings" />,
      selected: currentPage === 'ProfileSettingsPage',
      disabled: false,
      linkProps: {
        name: 'ProfileSettingsPage',
      },
    },
    {
      text: <FormattedMessage id="UserNav.accountSettings" />,
      selected: ACCOUNT_SETTINGS_PAGES.includes(currentPage),
      disabled: false,
      linkProps: {
        name: 'ContactDetailsPage',
      },
    },
  ];

  if( hasPermissionToPostListings( currentUser )){
    const yourListingsTab =
      {
        text: <FormattedMessage id="UserNav.yourListings" />,
        selected: currentPage === 'ManageListingsPage',
        linkProps: {
          name: 'ManageListingsPage',
        },
      };

    tabs = [ yourListingsTab, ...tabs ];
  }

  if( showSponsorListingsLink ) {
    const sponsorListingsTab = {
      text: <FormattedMessage id="ManageSponsorListingsPage.yourListings"/>,
      selected: currentPage === 'ManageSponsorListingsPage',
      linkProps:
      {
        name: 'ManageSponsorListingsPage',
      },
    };

    tabs = [ sponsorListingsTab, ...tabs ];
  }


  return (
    <LinkTabNavHorizontal className={classes} tabRootClassName={css.tab} tabs={tabs} skin="dark" />
  );
};

export default UserNav;
